import { WishlistItemResource, WishlistResource } from '../../@api/Sylius';
import { Wishlist } from './Wishlist';

export const transformToVariantIds = (resource: WishlistItemResource): string => resource.variant.id.toString();

export const transformToWishlist = (resource: WishlistResource): Wishlist => {
    const variantIds = resource.wishlistProducts.map(transformToVariantIds);

    return {
        id: resource.token,
        variantIds,
    };
};
